// ✅ DeliveryPartnerPanel.jsx — Legacy route redirect to new partner dashboard
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const DeliveryPartnerPanel = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the new partner dashboard
    navigate("/partner/dashboard", { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-green-50">
      <div className="text-center">
        <div className="text-4xl mb-4">🚚</div>
        <h2 className="text-xl text-green-700 mb-2">Redirecting...</h2>
        <p className="text-gray-600">Taking you to your dashboard</p>
      </div>
    </div>
  );
};

export default DeliveryPartnerPanel;
